import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SolicitudFirmaComponent } from './solicitud-firma.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AsociacionFirmaModule } from '../asociacion-firma-documento/asociacion-firma-documento.module';



@NgModule({
  declarations: [SolicitudFirmaComponent],
  imports: [
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    AsociacionFirmaModule,
],
  exports: [
    SolicitudFirmaComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class SolicitudFirmaModule { }